import { INavItens } from "@interfaces/INavItens";
import i18next from "i18next";
import {
  FaHome,
  FaClipboardList,
  FaChartBar,
  FaUsers,
  FaCamera,
  FaIndustry,
  FaAddressBook,
  FaBuilding,
  FaWarehouse,
  FaUniversity,
  FaUserPlus,
  FaFileInvoiceDollar,
  // FaMoneyCheckAlt,
  FaSearchDollar,
  FaUpload,
  FaUmbrellaBeach,
  FaReceipt,
  FaUserShield,
  FaShieldAlt,
  FaCalendarCheck,
  FaClipboardCheck,
  FaSignOutAlt,
} from "react-icons/fa";

export default async function RBACNav(
  getInfo: any,
  hasPermission: any,
  user: any
) {
  if (getInfo.roles === undefined || getInfo.userType === undefined) {
    // navigate("/landing")
    return [] as INavItens[];
  }
  const roles = getInfo.roles;
  const isPayrollAdmin = getInfo.roles.some(
    (role: any) => role.name === "Payroll Admin"
  );
  const navItems: INavItens[] = [];
  if (
    hasPermission(roles, "Sadmin landing", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 1,
      name: i18next.t("nav.home"),
      path: "/react/sadmin/landing",
      icon: FaHome,
    });
  }
  if (hasPermission(roles, "Plant Timesheets", "Access")) {
    navItems.push({
      id: 101,
      name: i18next.t("nav.pastReportsMobile"),
      path: "/react/admin/plant-timesheets",
      icon: FaClipboardList,
    });
  }
  if (
    hasPermission(roles, "Territory Reports", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 102,
      name: i18next.t("nav.pastReportsV2"),
      path: "/react/mgmt/territory-reports",
      icon: FaChartBar,
    });
  }
  if (
    hasPermission(roles, "Roster", "Access")
    // && getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 103,
      name: i18next.t("nav.roster"),
      path: "/react/roster",
      icon: FaUsers,
    });
  }
  if (
    hasPermission(roles, "Add User Picture", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 104,
      name: i18next.t("nav.addUserPicture"),
      path: "/react/usersprofile",
      icon: FaCamera,
    });
  }
  if (
    hasPermission(roles, "Plant List", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 105,
      name: i18next.t("nav.plantList"),
      path: "/react/plant-list",
      icon: FaIndustry,
    });
  }
  if (
    hasPermission(roles, "Client List", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 113,
      name: i18next.t("nav.clientList"),
      path: "/react/client-list",
      icon: FaAddressBook,
    });
  }
  if (
    hasPermission(roles, "Company List", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 114,
      name: i18next.t("nav.companyList"),
      path: "/react/company-list",
      icon: FaBuilding,
    });
  }
  if (
    hasPermission(roles, "Facility List", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 115,
      name: i18next.t("nav.facilityList"),
      path: "/react/facility-list",
      icon: FaWarehouse,
    });
  }
  if (
    isPayrollAdmin &&
    hasPermission(roles, "Bank Account List", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 106,
      name: i18next.t("nav.bankAccountList"),
      path: "/react/bank-accounts",
      icon: FaUniversity,
    });
  }
  if (
    hasPermission(roles, "Contractor Create", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 107,
      name: i18next.t("nav.contractorCreate"),
      path: "/react/contractor/create",
      icon: FaUserPlus,
    });
  }
  // if (
  //   hasPermission(roles, "Invoice", "Access") &&
  //   getInfo.userType === "super_admin"
  // ) {
  //   navItems.push({
  //     id: 108,
  //     name: i18next.t("nav.invoice"),
  //     path: "/react/invoice",
  //     icon: FaFileInvoiceDollar,
  //   });
  // }
  // if (
  //   hasPermission(roles, "Payroll", "Access") &&
  //   getInfo.userType === "super_admin"
  // ) {
  //   navItems.push({
  //     id: 108,
  //     name: i18next.t("nav.payroll"),
  //     path: "/react/payroll",
  //     icon: FaMoneyCheckAlt,
  //   });
  // }
  if (
    hasPermission(roles, "Payroll Review", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 110,
      name: i18next.t("nav.payrollReview"),
      path: "/react/admin/payroll-review",
      icon: FaSearchDollar,
    });
  }
  if (
    hasPermission(roles, "Invoice", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 111,
      name: i18next.t("nav.arInvoiceReview"),
      path: "/react/admin/ar-invoice-review",
      icon: FaFileInvoiceDollar,
    });
  }
  if (hasPermission(roles, "Hours Upload", "Access")) {
    navItems.push({
      id: 109,
      name: i18next.t("nav.hoursUpload"),
      path: "/react/hours-upload",
      icon: FaUpload,
    });
  }
  if (getInfo.userType === "user" && getInfo.user_id) {
    navItems.push({
      id: 1,
      name: i18next.t("nav.home"),
      path: `/react/contractor/${getInfo.user_id}`,
      icon: FaHome,
    });
    navItems.push({
      id: 160,
      name: i18next.t("nav.ptoRequests"),
      path: "/react/ptoRequests",
      icon: FaUmbrellaBeach,
    });
    navItems.push({
      id: 162,
      name: i18next.t("nav.pastStubs"),
      path: `/react/contractor/${getInfo.worker_id}/statement-history`,
      icon: FaReceipt,
    });
  }
  if (
    hasPermission(roles, "Admin Registration", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 111,
      name: i18next.t("nav.adminRegistration"),
      path: "/react/admin-registration",
      icon: FaUserShield,
    });
  }
  if (
    hasPermission(roles, "Policy Management", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 112,
      name: i18next.t("nav.policyManagement"),
      path: "/react/admin/policies",
      icon: FaShieldAlt,
    });
  }
  if (
    hasPermission(roles, "PTO Admin", "Access")
    // getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 210,
      name: i18next.t("nav.ptoAdmin"),
      path: "/react/admin/pto",
      icon: FaCalendarCheck,
    });
  }
  if (
    hasPermission(roles, "Audit", "Access") &&
    getInfo.userType === "super_admin"
  ) {
    navItems.push({
      id: 212,
      name: i18next.t("nav.auditLogs"),
      path: "/react/admin/audit",
      icon: FaClipboardCheck,
    });
  }
  // if (hasPermission(roles, "Logout", "Access")) {
  navItems.push({
    id: 1000,
    name: i18next.t("nav.logout"),
    path: "/react/logout",
    icon: FaSignOutAlt,
  });
  // }
  return navItems;
}
